export const dark = {
  title: 'dark',
  colors: {
    primary: '#e559f9',
    background: '#222',
    text: '#FFF',
    textSecondary: '#a8a8b3',
    backgroundBox: '#222',
  },
};